import { GUIDE_QUEST_ENABLED } from "../data/guideQuestData.js";

export const LEGACY_MAIN_TUTORIAL_AUTO_START_ENABLED = !GUIDE_QUEST_ENABLED;
export const LEGACY_TAB_TUTORIAL_AUTO_START_ENABLED = !GUIDE_QUEST_ENABLED;
